import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import ApiDocs from './pages/ApiDocs';
import FrontendDocs from './pages/FrontendDocs';
import ComponentLibrary from './pages/ComponentLibrary';
import ApiReference from './pages/ApiReference';
import './index.css'; // Import Tailwind CSS

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/api-docs" element={<ApiDocs />} />
          <Route path="/api-reference" element={<ApiReference />} />
          <Route path="/frontend-docs" element={<FrontendDocs />} />
          <Route path="/component-library" element={<ComponentLibrary />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;

